module.exports = __webpack_public_path__ + "img/ai3.5c05c08b.png";